
//decimal,text,tel,numeric,search,email,url
//enter,done,go,next,previous,search,send
import { Fragment } from "vue-frag";
export default {
  components: { Fragment },
  props: ["element"],
  name: "hyperCoreInput",
  methods: {
    dirty() {
      try{
        if (process.browser) {
        let input = document.querySelector(`[data-shopster_id="${this.element.shopster_id}"] input`);
        if (!input.value) {
          return "";
        }
        return "dirty";
      }
      }catch(e){
      }
      
    },
    binderEvent(v) {
      if (!this.element.bind) {
        return;
      }
      this.$store.commit("binder", {
        path: this.element.bind,
        value: v.target.value,
      });
    },
    binder() {
      if (!this.element.bind) {
        return {};
      }
      return {
        value: this.$hyperUtility.reactiveText(`{{${this.element.bind}}}`),
      };
    },
    percentage(v) {
      if (v == "auto" || v == "" || !v) {
        return "auto";
      }
      return isNaN(v) ? v : v + "px";
    },
  },
};
